import { render, staticRenderFns } from "./Lgx279928282189660160.vue?vue&type=template&id=8ffb9792&"
import script from "./Lgx279928282189660160.vue?vue&type=script&lang=js&"
export * from "./Lgx279928282189660160.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports